<template>
    <div class="d-lg-flex flex-collum coluna-2">
        <div class="flex-lg-fill" id="painel-horarios">
            <div class="card painel">
                <div class="card-body">
                    <div class="row m-3">
                        <div class="col-12">
                            <span class="calendario-dt-evento fa-stack fa-3x float-start">
                                <i class="far fa-calendar fa-stack-2x"></i>
                                <strong class="fa-stack-1x calendar-text text-center">
                                    19<br /><small>mar</small>
                                </strong>
                            </span>
                            <span class="dia-evento">Terça-feira</span>
                            <br />
                            <span class="area-oficina">
                                (On Line)O novo pregão eletrônico da IN nº 73/2022: aprendendo na prática
                            </span>
                            <br />
                            <span class="agenda-oficina">
                                <i class="far fa-clock"></i>
                                10:30 - 12:30
                            </span>
                            <br />
                            <span class="agenda-oficina">
                                <i class="far fa-clock"></i>
                                14:00 - 16:00
                            </span>
                        </div>
                        <div class="col-12 mt-4">
                            <span class="calendario-dt-evento fa-stack fa-3x float-start">
                                <i class="far fa-calendar fa-stack-2x"></i>
                                <strong class="fa-stack-1x calendar-text text-center">
                                    20<br /><small>mar</small>
                                </strong>
                            </span>
                            <span class="dia-evento">Quarta-feira</span>
                            <br />
                            <span class="area-oficina">
                                (On Line)Contratações diretas na NLL: entendendo o Sistema de Dispensa Eletrônica (IN nº 67/2021)
                            </span>
                            <br />
                            <span class="agenda-oficina">
                                <i class="far fa-clock"></i>
                                10:30 - 12:30
                            </span>
                            <br />
                            <span class="agenda-oficina mb-3">
                                <i class="far fa-clock"></i>
                                14:00 - 16:00
                            </span>
                        </div>
                        <div class="col-12 mt-4">
                            <span class="calendario-dt-evento fa-stack fa-3x float-start">
                                <i class="far fa-calendar fa-stack-2x"></i>
                                <strong class="fa-stack-1x calendar-text text-center">
                                    21<br /><small>mar</small>
                                </strong>
                            </span>
                            <span class="dia-evento">Quinta-feira</span>
                            <br />
                            <span class="area-oficina">
                                (On Line)Fraudes e conluios nas licitações: como prevenir, detectar e quais providencias adotar
                            </span>
                            <br />
                            <span class="agenda-oficina">
                                <i class="far fa-clock"></i>
                                10:30 - 12:30
                            </span>
                            <br />
                            <span class="agenda-oficina mb-3">
                                <i class="far fa-clock"></i>
                                14:00 - 16:00
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex-lg-fill">
            <div class="card painel" id="painel-sucesso">
                <div class="card-body">
                    <span class="d-flex justify-content-center sucess-span"><i class="fas fa-check-circle sucess-span me-2 mt-2"></i>Seleção de Oficinas Realizada com Sucesso!</span>
                    <span class="d-flex justify-content-center span-text mt-2"><i class="fas fa-calendar-alt span-text me-2" id="span-text-icon"></i>16/08/2024 15:31</span>
                    <span class="d-flex justify-content-center mt-3">
                        <button class="btn btn-danger p-1 mt-0 mb-0 rounded"><i class="fas fa-print me-1"></i>Imprimir</button>
                        <button class="btn btn-yellow p-1 ms-1 mt-0 mb-0 rounded"><i class="fas fa-sync me-1"></i>Voltar à Seleção de Oficinas</button>
                        <button class="btn btn-green p-1 ms-1 mt-0 mb-0 rounded"><i class="fas fa-arrow-right me-1"></i>Site do Evento</button>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Confirmado",
        components: {},
    }
</script>

<style scoped>

    .coluna-2 {
        margin: 30px !important;
        margin-top: 0;
    }

    @media (min-width: 680px) {
        .coluna-2 {
            margin: 60px !important;
            margin-top: 30px !important;
            margin-bottom: 0;
        }
    }

    @media (min-width: 992px) {
        .coluna-2 {
            margin: 30px !important;
            margin-top: 0 !important;
            margin-bottom: 0;
        }
    }

    .dia-evento {
        text-transform: uppercase;
        color: rgb(0, 167, 170);
        border-bottom: 1px solid #ececec;
        font-weight: 600;
        margin-left: 15px;
        font-size: 14px;
    }

    .agenda-oficina {
        color: #7a7a7a;
        text-transform: uppercase;
        font-size: 13px;
        font-weight: 600;
        margin-left: 5em;
    }

    .area-oficina {
        color: #7a7a7a;
        text-transform: uppercase;
        font-size: 13px;
        font-weight: 600;
        margin-left: 15px;
    }

    .sucess-span {
        color: #3c763d;
        font-weight: 600;
        font-size: 20px;
    }

    .span-text {
        color: #7a7a7a;
        font-weight: 600;
        font-size: 16px;
    }

    #painel-sucesso {
        padding-top: 20px;
        margin-bottom: 30px;
        padding-bottom: 20px;
        margin-top: 30px;
    }

    @media (min-width: 992px) {
        #painel-sucesso {
            margin-left: 30px;
            padding-top: 20px;
            padding-bottom: 20px;
            margin-bottom: 0px;
            margin-top: 0px;
        }
    }

    #span-text-icon {
        font-size: 24px
    }

    .btn-danger {
        color: #fff;
        background-color: #d9534f;
        border-color: #d43f3a;
        font-size: 15px;
    }

    .btn-yellow {
        background-color: #f0ad4e;
        border-color: #eea236;
        color: #fff;
        font-size: 15px;
    }

    .btn-green {
        background-color: #5cb85c;
        border-color: #4cae4c;
        color: #fff;
        font-size: 15px;
    }

    #painel-horarios {
        width: 100%;
    }

    @media (min-width: 992px) {
        #painel-horarios {
            width: 50%;
        }
    }

    .calendario-dt-evento strong {
        color: #7a7a7a;
        line-height: 12px;
        font-size: 15px;
        margin-top: 1.2em;
        text-transform: uppercase;
    }

    .fa-stack-2x {
        font-size: 2em;
        color: #7a7a7a;
        margin-top: 2px;
    }

    .calendario-dt-evento {
        font-size: 24px;
        color: #7a7a7a;
    }

    .fa-stack {
        position: relative;
        width: 2em;
        height: 2em;
        line-height: 2em;
        vertical-align: middle;
    }

</style>